export const NATIVE_SESSION_COOKIE = 'autocontrol_native_session';
export const NATIVE_CSRF_COOKIE = 'autocontrol_native_csrf';
export const NATIVE_CSRF_HEADER = 'x-csrf-token';

export const NATIVE_USER_NAV: readonly { readonly path: string; readonly label: string }[] = [
  { path: '/booking', label: 'Новая запись' },
  { path: '/my', label: 'Мои заявки' },
  { path: '/account', label: 'Пользователь' },
];
